"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const autosave_1 = require("../../../../hooks/autosave");
const validation_1 = require("../../../../hooks/validation");
const TaskPage_1 = require("../../base/TaskPage");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const FormInput_1 = require("../../../components/input/text/FormInput");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
exports.default = (props) => {
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [valid, errMsg] = (0, validation_1.usePropertyValidation)('internal_name', property);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.INTERNAL_NAME, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Identifying your property"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "We ask for a property nickname to make it easier for you to identify different properties."),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "The nickname is only used in your Travelnest account, it won\u2019t be seen on channels or by guests."),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(FormInput_1.FormInput, { id: "property-nickname-input", label: "Property nickname", value: property === null || property === void 0 ? void 0 : property.internal_name, valid: valid, errorMessage: errMsg, onChange: (e) => update({ internal_name: e.target.value }), minLength: 1, maxLength: 30 }))))));
};
//# sourceMappingURL=InternalNamePage.js.map